import styled from "styled-components";
import { Button } from "../../../../../../../base/buttons/button/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../../styles/common/mixins/logical.styled.js";
import counterButtonThemes from "./themes/index.js";
export const CounterButtonWrapper = styled(Button).withConfig({
    displayName: "styled__CounterButtonWrapper",
    componentId: "sc-6b47b844-0"
})`
	${BorderRadius({
    all: '50%'
})}
	${FlexMixin({
    justify: 'center',
    align: 'center'
})}
	background-color: ${({ theme  })=>theme.colors.counter?.background};
	color: ${({ theme  })=>theme.colors.counter?.base};
	border: 2px solid ${({ theme  })=>theme.colors.counter?.base};

	& i {
		${FontMixin({
    weight: 'bold',
    size: 'medium'
})}
	}

	&:focus {
		background-color: ${({ theme  })=>theme.colors.counter?.focusBg ?? theme.colors.white.base};
		color: ${({ theme  })=>theme.colors.counter?.focus ?? theme.colors.primary.light};
	}

	&:hover {
		background-color: ${({ theme  })=>theme.colors.counter?.hoverBg};
		color: ${({ theme  })=>theme.colors.counter?.hover};
	}

	&:disabled {
		opacity: 1;
		background-color: ${({ theme  })=>theme.colors.counter?.disabledBg};
		border-color: ${({ theme  })=>theme.colors.counter?.disabled};
		color: ${({ theme  })=>theme.colors.counter?.disabled};
	}

	${({ theme  })=>counterButtonThemes[theme.id]?.CounterButtonWrapper?.()};
`;

//# sourceMappingURL=styled.js.map